import { render, staticRenderFns } from "./PainelProjetosDintec.vue?vue&type=template&id=ee0b0814"
import script from "./PainelProjetosDintec.vue?vue&type=script&lang=js"
export * from "./PainelProjetosDintec.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosDintec.vue?vue&type=style&index=0&id=ee0b0814&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports